import React from 'react';
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function CollectionInnerPageBanner({bannerImage}) {

  return ( 
      <section className='common-banner-sec collection-inner-page-banner' 
      style={{
        backgroundImage: `url(${
          apiUrl.apiUrl + `/` + bannerImage
        })`,
      }}
      >
        
      </section> 
  );
}

export default CollectionInnerPageBanner;